import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import "./Edit_Complaints.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useState } from "react";
function Edit_Complaints({ onCancel ,handleClose}) {
   const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">

        <div className="row">

          {/* Sample ID */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Sample ID</Form.Label>
              <Form.Control defaultValue="SAMP101" />
            </Form.Group>
          </div>

          {/* Customer Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control defaultValue="Oashin Kawale" />
            </Form.Group>
          </div>

          {/* Customer ID */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Customer ID</Form.Label>
              <Form.Control defaultValue="Cust ID 1234" />
            </Form.Group>
          </div>

          {/* Contact Person Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Contact Person Name</Form.Label>
              <Form.Control defaultValue="Prathemesh Raut" />
            </Form.Group>
          </div>

          {/* Contact No */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>(Contact Person) Contact No.</Form.Label>
              <Form.Control defaultValue="1234567891" />
            </Form.Group>
          </div>

          {/* Email */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>(Contact Person) Email</Form.Label>
              <Form.Control defaultValue="oashkawale@gmail.com" />
            </Form.Group>
          </div>

          {/* Nature Of Complaint */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Nature Of Complaint</Form.Label>
              <Form.Select>
                <option>Deficiency In Service</option>
                <option>Delay In Report</option>
                <option>Incorrect Result</option>
              </Form.Select>
            </Form.Group>
          </div>

          {/* Action Taken */}
          <div className="col-md-12">
            <Form.Group className="form_group">
              <Form.Label>Action Taken:</Form.Label>

              <div className="row action_taken_group">

                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    defaultChecked
                    label="Pending / Forwarded to Regulator/Company"
                  />
                  <p className="radio_help_text">
                    Your complaint has been successfully registered & sent to
                    the concerned party for resolution.
                  </p>
                </div>

                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Action Taken Report (ATR) Received"
                  />
                  <p className="radio_help_text">
                    The company or agency has submitted their report on what
                    action they have taken.
                  </p>
                </div>

                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Resolved / Satisfied"
                  />
                  <p className="radio_help_text">
                    The issue has been sorted out to your satisfaction
                    (often after you confirm the resolution).
                  </p>
                </div>

                <div className="col-md-4 mt-3">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Disposed"
                  />
                  <p className="radio_help_text">
                    The case is closed. This could be because it was resolved,
                    was not taken up, or you did not respond to an inquiry.
                  </p>
                </div>

              </div>
            </Form.Group>
          </div>

          {/* Remark */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control placeholder="Enter Remark" />
            </Form.Group>
          </div>

        </div>


        {/* Buttons */}
         <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>

      </div>
    </section>
  );
}

export default Edit_Complaints;
